import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/** Represents the component for transferring the conversation to a queue. */
export const ConversationsTableRowMenuTransferToQueue = ({ conversation, toggleDropdown, }) => {
    const dispatch = useAppDispatch();
    /** Handles transferring the conversation to a queue. */
    const handleClick = useCallback(() => {
        toggleDropdown();
        dispatch(appActions.showModal({
            modal: {
                type: 'app:conversationQueueTransfer',
                arg: { csid: conversation.id },
            },
        }));
        analytics.conversationsTransferToQueueClicked();
    }, [conversation.id, dispatch, toggleDropdown]);
    return (_jsx(ButtonList.Item, Object.assign({ onClick: handleClick }, { children: "Transfer to queue" })));
};
